<template>
  <div v-if="mng" id="Sales" class="animated slow fadeIn">
    <div class="input-group pl-0 mb-2 mt-2">
      <template>
        <div class="input-group-prepend">
          <span v-if="!spinner" class="input-group-text text-white cyan darken-4 animated fadeIn" title=""><i
              class="fa fa-search text-grey" aria-hidden="true"></i></span>
          <div v-if="spinner" class="input-group-text text-white cyan darken-4" style="z-index:100000;">
            <Circle8></Circle8>
          </div>
        </div>
        <input @input="debounceSearch" ref="inp" class="form-control" type="text" placeholder="Поиск"
          aria-label="Search" title="Введите ключевые слова в поле поиска">
        <span class="input-group-text text-white blue-grey darken-4 hoverable" title="Очистить поле ввода"
          @click="debounceClean()" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
        <download-excel v-if="salesSubMode === 'Visits'" class="btn btn-sm default-color" :fetch="fetchData"
          :before-finish="finishDownload" :fields="json_fields" :stringifyLongNum="true" worksheet="My Worksheet"
          name="b2b-export.xls">
          Загрузить в Excel
        </download-excel>
        <download-excel v-if="salesSubMode === 'bonus' && boss" class="btn btn-sm default-color" :fetch="fetchDataBonus"
          :before-finish="finishDownloadBonus" :fields="json_fields_bonus" :stringifyLongNum="true" worksheet="Bonus"
          name="b2b-bonus.xls">
          Загрузить в Excel
        </download-excel>
        <download-excel v-if="salesSubMode === 'SpecialOrdersRefresh' && mng" class="btn btn-sm default-color"
          :fetch="fetchDataSpecial" :before-finish="finishDownloadSpecial" :fields="json_fields_Special"
          :stringifyLongNum="true" worksheet="specialOrders" name="specialOrders.xls">
          Загрузить в Excel
        </download-excel>
        <download-excel v-if="salesSubMode === 'CRM' && mng" class="btn btn-sm default-color" :fetch="fetchDataDolg"
          :before-finish="finishDownloadDolg" :fields="json_fields_dolg" :stringifyLongNum="true"
          worksheet="My Worksheet" name="dolg.xls">
          Должники в Excel
        </download-excel>
        <download-excel v-if="salesSubMode === 'quiz' && mng" class="btn btn-sm default-color" :fetch="fetchDataQuiz"
          :before-finish="finishDownload" :fields="json_fields_quiz" :stringifyLongNum="true"
          worksheet="My Worksheet" name="quiz.xls">
          Опросы в Excel
        </download-excel>
      </template>
    </div>
    <template v-if="salesSubMode === 'Visits' && !hidechart && !spinner">
      <div class="pl-3 pr-3">
        <card title="Заказы из B2B">
          <card-body>
            <div style="display: block">
              <bar-chart :data="barChartData()" :options="barChartOptions" :height="200"></bar-chart>
            </div>
          </card-body>
        </card>
      </div>
      <div v-if ="false" class="row pl-3 pr-3">
        <div v-for="(order, index) in filteredListVisits" :key=index class="card col-md-4 mb-2 cascading-admin-card">
          <div class="card-header d-flex mb-3">
            <div style="cursor: pointer;">
              {{ order.Kontragent }} УНП: {{ order.Login }}
            </div>
          </div>
          <div class="card-body">
            {{ order.Ordernumber }} от {{ formatDate(order.OrderDate) }}
          </div>
          <div class="card-footer">
            {{ order.OsnmanagerCode }}
          </div>
        </div>
      </div>
    </template>
    <template v-if="salesSubMode === 'quiz' && !hidechart && !spinner">
      <div class="pl-3 pr-3">
        <card>
          <card-header>
            Результаты опроса: {{ quizlist.length }}
          </card-header>
          <card-body>
            <div style="display: block">

            </div>
          </card-body>
        </card>
      </div>
      <div class="row pl-3 pr-3">
        <div v-for="(el, index) in quizlist" :key=index class="card col-md-4 mb-2 cascading-admin-card">
          <div class="card-header d-flex mb-3">
            <div style="cursor: pointer;">
              {{ el }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="d-flex justify-content-center"
      v-if="salesSubMode === 'SpecialOrdersRefresh' && groupedRecords.length >= 500">
      <badge class="info-color">Слишком много записей для показа - используйте фильтр</badge>
    </div>
    <div v-if="salesSubMode === 'SpecialOrdersRefresh' && !spinner && !hidechart && groupedRecords.length < 500"
      v-for="(order, index) in groupedRecords " :key="index" class="card col-md-12 mb-2 cascading-admin-card">
      <div>
        <div class="d-flex flex-wrap justify-content-start align-self-center input-group-text small" readonly
          @click="selectSpecialOrder(order.data[0].guid)">
          <p class="ml-auto col-sm-auto align-self-center input-group-text" readonly><small> {{ order.date }} №
              {{ order.number }}</small></p>
          <p class="ml-auto col-sm-auto align-self-center input-group-text" readonly title="Менеджер">
            <small>{{ order.manager }} </small>
          </p>
          <select v-bind:value="order.type" style="font-size: 12px;" disabled class="ml-auto col-sm-1 input-group"
            title="Тип заказа">
            <option v-for="(type, index) in specialOrdersTypeList " :key="index" :value="index">{{ type }}</option>
          </select>
          <select v-bind:value="order.sklad" style="font-size: 12px;" readonly disabled
            class="ml-auto col-sm-1 input-group-text small" title="Склад">
            <option v-for="(sklad, index) in specialOrdersSkladList " :key="index" :value="index">
              <small>{{ sklad }}</small>
            </option>
          </select>
          <input style="font-size: 12px;" class="mr-auto col-sm-2 input-group-text-sm" readonly type='text'
            v-bind:value="order.client" aria-label="Клиент" title="Клиент" />
          <input style="font-size: 12px;" class="mr-auto col-sm input-group-text-sm" readonly type='text'
            v-bind:value="order.good" aria-label="Товар" title="Товар" />
          <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group-text-sm" readonly type='text'
            v-bind:value="order.quantity" aria-label="Количество" title="Количество" />
        </div>

        <div v-for="(resp, index) in order.data " :key="index" @click="selectSpecialOrder(resp.guid)"
          class="d-flex flex-wrap justify-content-start align-self-center input-group-text-sm">
          <input style="font-size: 12px;" class="mr-auto col-sm-2 input-group" type='text' v-bind:value="resp.price"
            v-on:change="updatePrice($event.target.value, resp.guid)" aria-label="Цена" title="Цена" />
          <input style="font-size: 12px;" class="mr-auto col-sm-1 input-group" type='text' v-bind:value="resp.term"
            v-on:change="updateTerm($event.target.value, resp.guid)" aria-label="Срок" title="Срок поставки" />
          <input style="font-size: 12px;" class="mr-auto col-sm input-group" type="textarea"
            v-bind:value="resp.response" v-on:change="updateResponse($event.target.value, resp.guid)"
            aria-label="Комментарий" title="Комментарий" />

          <select v-bind:value="parseInt(resp.supplier)" v-on:input="updateSupplier($event.target.value, resp.guid)"
            style="font-size: 12px;" class="col-sm-1 input-group" title="Поставщик">
            <option v-for="(supplier, index) in suppliers" :key="index" :value="index"><small>{{ supplier }}</small>
            </option>
          </select>
          <select v-bind:value="parseInt(resp.status)" v-on:input="updateStatus($event.target.value, resp.guid)"
            style="font-size: 12px;" class="ml-auto col-sm-1 input-group small"
            :class="{ ' lime lighten-5': resp.status === 2, 'rgba-green-slight': resp.status === 3, 'light-blue lighten-5': resp.status === 4, 'teal lighten-5': resp.status === 5, 'amber darken-4': resp.status === 6, 'success-color': resp.status === 7 }"
            title="Статус">
            <option v-for="(status, index) in specialOrdersStatusList " :key="index" :value="index">
              <small>{{ status }}</small>
            </option>
          </select>
          <template>
            <div class="input-group-prepend">
              <b v-if="resp.status === 7" style="font-size: 12px;"
                class="mr-auto align-self-center input-group-text small"><small>Заказ</small></b>
              <input v-if="resp.status === 7" style="font-size: 12px;" class="ml-auto col-sm red-text input-group small"
                type='text' v-bind:value="resp.ordernumber"
                v-on:change="updateOrdernumber($event.target.value, resp.guid)" aria-label="Заказ в базе"
                title="Заказ в базе" />
              <span v-if="resp.guid === selectedSpecialOrder" @click="copySpecialOrderFileManager(order)"
                type="btn btn-nav" class="input-group-text hoverable text-white info-color" title="Копия"><i
                  class="fa-regular fa-square-plus"></i></span>
              <button v-if="false && resp.guid === selectedSpecialOrder" @click="changeStatus(resp.guid)"
                type="btn btn-nav" class="input-group-text text-white hoverable info-color small" title="Сохранить"><i
                  class="fa fa-check"></i></button>
            </div>
          </template>

        </div>
      </div>
    </div>

    <template v-if="salesSubMode === 'bonus' && !hidechart">
      <div class="pl-3 pr-3">
        <card title="Ход проведения акции">
          <card-body>
            <div style="display: block">
              <bar-chart :data="barChartDataBonus()" :options="barChartOptions1" :height="400"></bar-chart>
            </div>
          </card-body>
        </card>
      </div>
      <div class="row pl-3 pr-3">
        <div v-for="(bonus, index) in filteredListBonus" :key=index class="card col-md-4 mb-2 cascading-admin-card">
          <div class="card-header d-flex mb-3">
            <div style="cursor: pointer;">
              {{ bonus.Kontragent }}<br>
              УНП: {{ bonus.UNP }}
            </div>
          </div>
          <div class="card-body">
            План:{{ bonus.Plan }} Продано:{{ bonus.Prodano }} = <b>{{ bonus.ProcentVipolneniya }}%</b>
          </div>
          <div class="card-footer">
            {{ bonus.Manager }}
          </div>
        </div>
      </div>
    </template>
    <template v-if="salesSubMode === 'CRM'">
      <div v-if="false" class="pl-3 pr-3">
        <card title="Заказы из B2B">
          <card-body>
            <div v-if="!hidechart" style="display: block">
              <bar-chart :data="barChartData3()" :options="barChartOptions3" :height="200"></bar-chart>
            </div>
          </card-body>
        </card>
      </div>
      <div class="row">
        <div v-if="!hidechart" v-for="(client, index) in filteredListCRM" :key=index
          class="card-group col-md-12 mb-2 cascading-admin-card">
          <div class="card">
            <div v-if="selectedManager.ManagerCode === 'ВСЕ'" class="card-header">
              Менеджер: {{ client.OsnmanagerCode }}
            </div>
            <div class="card-body d-flex mb-3">
              <div style="cursor: pointer;">
                {{ client.Kontragent }} ({{ client.UNP }})

              </div>

            </div>
            <div class="input-group-append col-3 ml-auto " style="cursor: pointer;">
              <button style="cursor: pointer;" class="hoverable btn btn-sm text-white mr-2"
                v-bind:class="{ 'success-color': client.classification === 'A' && client.classificationXYZ === 'X', 'success-color-dark': client.classification === 'A' && client.classificationXYZ === 'Y', 'default-color': client.classification === 'A' && client.classificationXYZ === 'Z', 'info-color': client.classification === 'B' && client.classificationXYZ === 'X', 'primary-color': client.classification === 'B' && client.classificationXYZ === 'Y', 'info-color-dark': client.classification === 'B' && client.classificationXYZ === 'Z', 'warning-color': client.classification === 'C' && client.classificationXYZ === 'X', 'warning-color-dark': client.classification === 'C' && client.classificationXYZ === 'Y', 'danger-color': client.classification === 'C' && client.classificationXYZ === 'Z' }"
                tag="a" title='Анализ клиента'> {{ client.classification }}{{ client.classificationXYZ }}
                {{ client.totalSum }} {{ client.totalInvoices }}
              </button>
            </div>
            <div class="card-footer">
              <button type="button" title="Баланс" class="btn btn-nav waves-effect cyan darken-3">{{ client.balance }}
                {{
                  client.priceCurrency }}</button>
              <button v-if="client.просроченныйДолг > 0" type="button"
                @click="showModal = true, selectedClient = client" title="Просроченный долг. Нажмите для детализации."
                class="btn btn-nav waves-effect"
                :class="{ 'red': client.днейПросрочки < -14, 'orange': client.днейПросрочки >= -14 }"> {{
                  client.просроченныйДолг }} {{ client.priceCurrency }} {{ client.днейПросрочки }}</button>
               <div v-if="client.ДатаНапоминания" class="p-2" title="Напоминание отправлено ">
                 {{ client.ДатаНапоминания }}
                  <i class="fa-solid fa-envelope-open-text fa-2xl"></i>
                </div>
              <div v-if="client.просроченныйДолг > 100"
                class="d-flex flex-row-reverse  align-items-center align-content-start">
                <div class="btn hoverable p-2 animated slow infinite rubberBand orange-text"
                 @click="sendReminder(client)"
                  title="Отправить напоминание"><i class="fa-solid fa-envelope-open-text fa-2xl"></i></div>
                {{ client.EmailDlyaRassylky }}
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div style="display: block">
                <bar-chart v-if="!hidechart" :data="barChartData1(client)" :options="barChartOptions1"
                  :height="200"></bar-chart>
              </div>
            </div>
          </div>
          <div v-if="false" class="card">
            <div class="card-header d-flex mb-3">
              {{ client.EmailDlyaRassylky }}
            </div>
            <div class="card-body d-flex flex-row justify-content-evenly center align-items-center">

              <h3 class="p-3 ml-3 cyan darken-3 bg-gradient text-white"><i
                  class="fa-solid fa-envelope-open-text fa-2xl"></i></h3>
              <h3 class="p-3 ml-3 cyan darken-3 bg-gradient text-white"><i
                  class="fa-solid fa-envelope-open-text fa-2xl"></i></h3>
              <h3 class="p-3 ml-3 cyan darken-3 bg-gradient text-white"><i
                  class="fa-solid fa-envelope-open-text fa-2xl"></i></h3>

            </div>
          </div>
        </div>
      </div>
    </template>
    <back-to-top bottom="5px" right="800px">
      <button @click="$refs.inp.focus()" type="button"
        class="btn cyan darken-3hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
    <modal class="mt-5" scrollable centered position="bottom" size="lg" v-if="showModal"
      @keydown.esc="showModal = false" @close="showModal = false">
      <modal-header>
        <modal-title>{{ selectedClient.Kontragent }}</modal-title>
      </modal-header>
      <modal-body v-if="selectedClient.просроченныйДолг === 0" class="col-md-12 text-center">
        Общий долг: <b>{{ selectedClient.balance }} {{ selectedClient.priceCurrency }}</b>
        Просроченный:<b>{{ selectedClient.просроченныйДолг }} {{ selectedClient.priceCurrency }}</b>
      </modal-body>
      <modal-body v-if="selectedClient.просроченныйДолг > 0" class="col-md-12 text-center">
        Общий долг: <b>{{ selectedClient.balance }} {{ selectedClient.priceCurrency }}</b> Просроченный: <b>
          <font color="red">{{ selectedClient.просроченныйДолг }} {{ selectedClient.priceCurrency }}</font>
        </b>
      </modal-body>
      <modal-body>
        <template>
          <div v-if="selectedClient.balance > 0">
            <tbl responsive>
              <tbl-head color="cyan darken-1" textWhite>
                <tr>
                  <th>№</th>
                  <th>Дата</th>
                  <th>Сумма к оплате</th>
                  <th>Дней отсрочки</th>
                  <th>Дней до оплаты</th>
                </tr>
              </tbl-head>
              <tbl-body v-for="(накладная, index) in selectedClient.накладные" :key="index">
                <tr>
                  <th scope="row">{{ накладная.NUM }}</th>
                  <td>{{ накладная.Date | moment("DD-MM-YYYY") }}</td>
                  <td v-if="накладная.ДнейДоОплаты >= 0">{{ Math.round(накладная.Summa * 100) / 100 }}
                    {{ накладная.Valuta }}</td>
                  <td v-if="накладная.ДнейДоОплаты < 0"><b>
                      <font color="red">{{ Math.round(накладная.Summa * 100) / 100 }} {{ накладная.Valuta }}</font>
                    </b></td>
                  <td>{{ накладная.DneyOtsrochki }}</td>
                  <td v-if="накладная.ДнейДоОплаты > 0">{{ накладная.ДнейДоОплаты }}</td>
                  <td v-if="накладная.ДнейДоОплаты <= 0"><b>
                      <font color="red">{{ накладная.ДнейДоОплаты }}</font>
                    </b></td>
                </tr>
              </tbl-body>
            </tbl>
          </div>
        </template>
      </modal-body>
      <modal-footer class="d-flex justify-content-around">
        <btn color="cyan darken-1" @click.native="showModal = false">Закрыть</btn>
      </modal-footer>
    </modal>
  </div>
</template>

<script>
import { mdbBtnGroup, Row, Container, Column, Btn, Card, CardGroup, CardTitle, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Carousel, CarouselItem, CarouselCaption, Tbl, TblHead, TblBody, mdbContainer, mdbRow, mdbCol, mdbInput, mdbTextarea, mdbBtn, mdbIcon, mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter } from 'mdbvue'
import ApiService from '@/services/ApiService'
import format from 'date-fns/format'
// import Nightmare from 'nightmare'
// import subDays from 'date-fns/sub_days'
import addDays from 'date-fns/add_days'
import getYear from 'date-fns/get_year'
import getMonth from 'date-fns/get_month'
import differenceInDays from 'date-fns/difference_in_days'
import JsonExcel from 'vue-json-excel'
// import startOfQuarter from 'date-fns/start_of_quarter'
// import endOfQuarter from 'date-fns/end_of_quarter'
// import axios from 'axios'
// import cheerio from 'cheerio'
import {
  Circle8
} from 'vue-loading-spinner'
export default {
  name: 'Sales',
  components: {
    JsonExcel,
    Circle8,
    mdbBtnGroup,
    Row,
    Column,
    Container,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardGroup,
    CardText,
    CardTitle,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Carousel,
    CarouselItem,
    CarouselCaption,
    Tbl,
    TblHead,
    TblBody,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter
  },
  props: ['activeMng', 'prihod', 'specialOrdersSkladList', 'specialOrdersSupplier', 'specialOrdersStatus', 'specialOrdersStatusList', 'specialOrdersType', 'specialOrdersTypeList', 'suppliers', 'bonus', 'loading', 'authorized', 'ai', 'balance', 'goods', 'orders', 'mng', 'boss', 'rate', 'contragents', 'folder1', 'folder2', 'partnersABCXYZ', 'selectedManager', 'partnersSalesByPeriod', 'startDate', 'endDate', 'user', 'salesReady', 'partnersDebt', 'partnerSales', 'partnerSalesTotal', 'managers', 'managersSales', 'managerSalesTotal', 'managerSales', 'salesSubMode', 'spinner'],
  data () {
    return {
      showModal: false,
      classifiedClients: {},
      lastStatus: 0,
      excelData: {},
      selectedClient: [],
      B2BOrdersList: [],
      specialOrders: [],
      selectedSpecialOrder: [],
      specialOrdersManager: [],
      specialOrdersSync: [],
      dateFormat1: 'YYYY-MM-DD H:mm:ss',
      excelReady: true,
      quizResults: [],
      loginLog: [],
      contragentName: '',
      contragentSales: [],
      maxnumber: 0,
      partnerKey: '',
      partnersPayments: {},
      partnersSales: [],
      phone: '',
      phoneCalls: [],
      promisesArray: [],
      price: '',
      auctions: [],
      term: '',
      response: '',
      quizlist: [],
      status: 0,
      supplier: 0,
      type: 0,
      sklad: 0,
      selectedclass: '',
      ordernumber: '',
      tag: '',
      message: '',
      results: [],
      years: [],
      compensation: 0,
      compensationRemains: 0,
      expectedProfit: 0,
      expectedProfitUpr: 0,
      // excelReady: false,
      // excelData: [],
      salesForecast: 0,
      currentPercent: 5,
      addedPercent: 0,
      search: '',
      hidechart: false,
      itemsSelected: 0,
      closetags: false,
      inlist: false,
      totalplan: 0,
      totalsales: 0,
      totalprofit: 0,
      totalprofitUpr: 0,
      cost: 21000,
      targetProfit: 3000,
      накладные: [],
      b2bOrdersUniq: 0,
      json_fields: {
        'Менеджер': 'Manager',
        'Контрагент': 'Contragent',
        'УНП': 'UNP',
        'Число посещений': 'Visits',
        'Кол-во заказов': 'Orders'
      },
      json_fields_quiz: {
        'id': 'id',
        'Сфера': 'Сфера',
        'Парк обсуживания': 'Парк',
        'Трудно Найти Запчасти': 'ТрудноНайтиЗапчасти',
        'Трудно Найти': 'ТрудноНайти',
        'Конкуренты': 'Конкуренты',
        'Что Добавить': 'ЧтоДобавить',
        'Новости': 'Новости',
        'Альтернативные Новости': 'АльтНовости'
      },
      json_fields_dolg: {
        'УНП': 'UNP',
        'Контрагент': 'Kontragent',
        'Общий долг': 'Отгружено',
        'Просроченная задолженность': 'просроченныйДолг',
        'Валюта': 'priceCurrency',
        'Дней просрочки': 'днейПросрочки',
        'Основной менеджер': 'OsnmanagerCode',
        'Проделанная работа': 'Взаимодействие'
      },
      json_fields_Special: {
        '№': 'number',
        'Версия': 'version',
        'Дата': 'date',
        'Менеджер': 'manager',
        'Клиент': 'client',
        'УНП менеджера': 'UNP',
        'УНП Клиента': 'ClientUNP',
        'Товар': 'good',
        'Количество': 'quantity',
        'Цена': 'price',
        'Ответ': 'response',
        'Срок': 'term',
        'Склад': 'sklad',
        'Тип': 'type',
        'Поставщик': 'supplier',
        'Статус': 'status',
        '№ заказа': 'ordernumber'
      },
      json_fields_bonus: {
        'Количество банок': 'KolBanok',
        '% скидки': 'ProcSK',
        'Сумма закупок': 'Summa',
        'Сумма скидки': 'SummaSK',
        'УНП': 'UNP',
        'Контрагент': 'Contragent'
      },
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      barChartOptions1: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true // This hides all text in the legend and also the labels.
        },
        scales: {
          xAxes: [{
            // barPercentage: 1,
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      },
      barChartData2: {
        labels: ['Прибыль', 'Прогноз', 'Цель', 'Осталось', 'Продажи', 'Прогноз', 'Осталось'],
        datasets: [
          {
            label: 'Бух',
            data: [0, 0, 0, 0, 0],
            backgroundColor: '#3F729B',
            borderWidth: 1
          },
          {
            label: 'Упр',
            data: [0, 0, 0, 0, 0],
            backgroundColor: '#33b5e5',
            borderWidth: 1
          }
        ]
      },
      barChartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true // This hides all text in the legend and also the labels.
        },
        scales: {
          xAxes: [{
            // barPercentage: 1,
            gridLines: {
              display: true,
              color: '#33b5e5'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.5)'
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }]
        }
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            // barPercentage: 1,
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  watch: {
    barChartData1 () {
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
    },
    barChartDataBonus () {
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
    },

    async salesSubMode () {
      this.hidechart = true
      //   console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
      if (this.salesSubMode === 'CRM') {
        try {
          const res = await ApiService.getContragentsInvoices()
          this.накладные = res.data
          this.getRemindersList()
          // console.log('1:', this.накладные.length)
          // console.log('Накладные:' + Math.floor(Date.now() / 1000))

          this.накладные = this.накладные.filter(invoice => getYear(invoice.Date) > this.years[2])
          console.log('2:', this.накладные.length)
          // console.log('Накладные:' + Math.floor(Date.now() / 1000))

          this.накладные = this.накладные.filter(invoice => invoice.Valuta !== 'USD')
          // console.log('3:', this.накладные.length)
          // console.log('Накладные:' + Math.floor(Date.now() / 1000))

          this.getContragentsInvoices()
        } catch (error) {
          console.error('Ошибка при получении данных:', error)
        }
      }
      if (this.salesSubMode === 'SpecialOrders') {
        this.$emit('load')
        await this.getSpecialOrders()
      }
      if (this.salesSubMode === 'parsing') {
        this.$emit('load')
        await this.getParsing()
      }
      if (this.salesSubMode === 'quiz') {
        this.$emit('load')
        await this.getQuiz()
      }
      if (this.salesSubMode === 'Visits') {
        this.$emit('load')
        console.log('Visits')
        this.getB2BOrdersList()
        this.getLoginLog()

        // console.log(this.chartDataUniq)
        this.b2bOrdersUniq = this.chartDataUniq.reduce(function (sum, elem) {
          return sum + elem
        }, 0)
        this.$emit('b2bOrdersUniq', { uniq: this.b2bOrdersUniq, total: this.filteredListVisits.length })
      }
    },
    startDate () {
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
      // console.log(this.chartDataUniq)
      this.b2bOrdersUniq = this.chartDataUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      this.chartLoginUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      // this.$emit('b2bOrdersUniq', this.b2bOrdersUniq)
      this.$emit('b2bOrdersUniq', { uniq: this.b2bOrdersUniq, total: this.filteredListVisits.length })
    },
    endDate () {
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
      // console.log(this.chartDataUniq)
      this.b2bOrdersUniq = this.chartDataUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      this.chartLoginUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      // this.$emit('b2bOrdersUniq', this.b2bOrdersUniq)
      this.$emit('b2bOrdersUniq', { uniq: this.b2bOrdersUniq, total: this.filteredListVisits.length })
    },
    selectedManager () {
      console.log('changeManager')
      this.b2bOrdersUniq = this.chartDataUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      this.chartLoginUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      this.$emit('b2bOrdersUniq', { uniq: this.b2bOrdersUniq, total: this.filteredListVisits.length })
      // console.log(this.chartDataUniq)
      /*
      if (this.selectedManager === '00000000-0000-0000-0000-000000000000') {
        this.$emit('DateSelected', {dateone: startOfQuarter(Date()), datetwo: endOfQuarter(Date())})
        this.calculateCompensation()
      }
      */
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
      // this.$data._chart.update()
    },
    search () {
      this.hidechart = true
      console.log('hidechart = true')
      setTimeout(() => { this.updateChart() }, 1)
    },
    filteredListVisits () {
      this.b2bOrdersUniq = this.chartDataUniq.reduce(function (sum, elem) {
        return sum + elem
      }, 0)
      this.$emit('b2bOrdersUniq', { uniq: this.b2bOrdersUniq, total: this.filteredListVisits.length })
    },
    totalprofit () {
      console.log('totalprofit')
    },
    partnersDebt () {
      /* if (this.partnersDebt) {
        this.filteredList.forEach((el) => {
          setTimeout(() => { this.getClientBalance(el.Партнер_Key) }, 1000)
        })
      }  */
    }
  },
  async mounted () {
    console.log('SALES MOUNTED')
    window.addEventListener('keydown', this.escCloseModal)
    // this.$emit('DateSelected', {dateone: subDays(Date(), 7), datetwo: addDays(Date(), 0)})
    this.$bus.$on('selectedclass', (event) => {
      this.selectedclass = event
      // console.log(event)
      this.hidechart = true
      setTimeout(() => { this.updateChart() }, 1)
    })
  },
  async updated () {
    // this.hidechart = false
    // this.$emit('spinneroff')
    // await this.updateChart()
  },
  created () {
  },
  beforeMount () {
    this.year()
  },
  beforeDestroy () {
    console.log('destroy')
    window.removeEventListener('keydown', this.escCloseModal)
    this.$emit('salesDestroy')
    this.contragents.sort((a, b) => {
      if (a.Description > b.Description) {
        return 1
      }
      if (a.Description < b.Description) {
        return -1
      }
      // a должно быть равным b
      return 0
    })
  },
  computed: {
    filteredListVisits () {
      // if (this.salesSubMode !== 'Visits') return
      console.log('Filtered Visits')
      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        // console.log(this.selectedManager)
        return this.B2BOrdersList.filter(order => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0) return true
          var res = true
          // console.log(differenceInDays(addDays(this.endDate, 0), addDays(order.OrderDate, 0)))
          keywords.forEach((element) => {
            var str = order.Kontragent + ' ' + order.OsnmanagerCode + ' ' + order.Login + ' ' + order.Ordernumber + ' ' + this.formatDate(order.OrderDate)
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false || new Date(order.OrderDate) < new Date(this.startDate) || new Date(order.OrderDate) > Date(this.endDate)) res = false
          })
          return res
        })
      } else {
        return this.B2BOrdersList.filter(order => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0) return true
          var res = true
          keywords.forEach((element) => {
            // console.log(good.НаименованиеПолное)
            var str = order.Kontragent + ' ' + order.OsnmanagerCode + ' ' + order.Login + ' ' + order.Ordernumber + ' ' + this.formatDate(order.OrderDate)
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true && order.OsnmanagerCode === this.selectedManager.ManagerCode) res = true
            if (res === false || res1 === false || order.OsnmanagerCode !== this.selectedManager.ManagerCode || differenceInDays(addDays(order.OrderDate, 0), addDays(this.startDate, -1)) <= 0 || differenceInDays(addDays(this.endDate, 0), addDays(order.OrderDate, 0)) < 0) res = false
          })
          return res
        })
      }
    },
    filteredListCRM () {
      // if (this.salesSubMode !== 'CRM') return
      console.log('filteredlistCRM')
      if (this.classifiedClients.length === 0 || this.classifiedClients.length === undefined) return false
      // console.log('Filtered CRM')
      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        // console.log(this.selectedManager)
        return this.classifiedClients.filter(client => {
          var keywords = this.search.split(' ')
          // if (keywords.length === 0) return true
          var res = true
          if (this.partnersDebt && (client.просроченныйДолг === undefined || client.просроченныйДолг === 0)) res = false
          if (this.selectedclass === 'AX' && (client.classification !== 'A' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'AY' && (client.classification !== 'A' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'AZ' && (client.classification !== 'A' || client.classificationXYZ !== 'Z')) res = false
          if (this.selectedclass === 'BX' && (client.classification !== 'B' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'BY' && (client.classification !== 'B' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'BZ' && (client.classification !== 'B' || client.classificationXYZ !== 'Z')) res = false
          if (this.selectedclass === 'CX' && (client.classification !== 'C' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'CY' && (client.classification !== 'C' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'CZ' && (client.classification !== 'C' || client.classificationXYZ !== 'Z')) res = false
          keywords.forEach((element) => {
            var str = client.Kontragent + ' ' + client.OsnmanagerCode + ' ' + client.UNP
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false) res = false
            if (this.partnersDebt && (client.просроченныйДолг === undefined || client.просроченныйДолг === 0)) res = false
          })
          return res
        })
      } else {
        return this.classifiedClients.filter(client => {
          // if (keywords.length === 0) return true
          var res = true
          if (this.partnersDebt && (client.просроченныйДолг === undefined || client.просроченныйДолг === 0)) res = false
          if (this.selectedclass === 'AX' && (client.classification !== 'A' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'AY' && (client.classification !== 'A' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'AZ' && (client.classification !== 'A' || client.classificationXYZ !== 'Z')) res = false
          if (this.selectedclass === 'BX' && (client.classification !== 'B' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'BY' && (client.classification !== 'B' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'BZ' && (client.classification !== 'B' || client.classificationXYZ !== 'Z')) res = false
          if (this.selectedclass === 'CX' && (client.classification !== 'C' || client.classificationXYZ !== 'X')) res = false
          if (this.selectedclass === 'CY' && (client.classification !== 'C' || client.classificationXYZ !== 'Y')) res = false
          if (this.selectedclass === 'CZ' && (client.classification !== 'C' || client.classificationXYZ !== 'Z')) res = false
          // console.log(differenceInDays(addDays(this.endDate, 0), addDays(order.OrderDate, 0)))
          var keywords = this.search.split(' ')
          keywords.forEach((element) => {
            var str = client.Kontragent + ' ' + client.OsnmanagerCode + ' ' + client.UNP
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false || client.OsnmanagerCode !== this.selectedManager.ManagerCode) res = false

            // 'success-color':client.classification === 'A' && client.classificationXYZ === 'X' ,'success-color-dark':client.classification === 'A'&& client.classificationXYZ === 'Y','default-color':client.classification === 'A'&& client.classificationXYZ === 'Z' ,'info-color':client.classification === 'B'&& client.classificationXYZ === 'X' ,'primary-color':client.classification === 'B'&& client.classificationXYZ === 'Y' ,'info-color-dark':client.classification === 'B'&& client.classificationXYZ === 'Z' ,'warning-color':client.classification === 'C' && client.classificationXYZ === 'X','warning-color-dark':client.classification === 'C'&& client.classificationXYZ === 'Y' ,'danger-color':client.classification === 'C'&& client.classificationXYZ === 'Z'
          })
          return res
        })
      }
    },
    filteredListBonus () {
      // if (this.salesSubMode !== 'bonus') return
      console.log('Filtered Bonus')
      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        // console.log(this.selectedManager)
        return this.bonus.filter(bonus => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0) return true
          var res = true

          keywords.forEach((element) => {
            var str = bonus.Kontragent + ' ' + bonus.UNP
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false) res = false
          })
          return res
        })
      } else {
        return this.bonus.filter(bonus => {
          var keywords = this.search.split(' ')
          if (keywords.length === 0) return true
          var res = true
          // console.log(differenceInDays(addDays(this.endDate, 0), addDays(order.OrderDate, 0)))
          keywords.forEach((element) => {
            var str = bonus.Kontragent + ' ' + bonus.Manager + ' ' + bonus.UNP
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false || bonus.Manager !== this.selectedManager.ManagerCode) res = false
          })
          return res
        })
      }
    },
    filteredListSpecialOrders () {
    //  console.log('filteredListSpecialOrders' + Math.floor(Date.now() / 1000))

      // if (this.salesSubMode !== 'SpecialOrdersRefresh') return
      var filteredArray = this.specialOrders.filter(order => {
        var keywords = this.search.split(' ')
        var res = true
        if (parseInt(this.specialOrdersSupplier) !== parseInt('0') && parseInt(order.supplier) !== parseInt(this.specialOrdersSupplier)) res = false
        if (!this.prihod) {
          if (parseInt(this.specialOrdersStatus) !== parseInt('0') && parseInt(order.status) !== parseInt(this.specialOrdersStatus)) res = false
          if (parseInt(this.specialOrdersStatus) !== parseInt('8') && parseInt(order.status) === 8) res = false
        }
        if (this.prihod && (parseInt(order.status) !== 5 && parseInt(order.status) !== 7)) res = false
        if (parseInt(this.specialOrdersType) !== parseInt('0') && parseInt(order.type) !== parseInt(this.specialOrdersType)) res = false
        if (format(order.date, 'YYYY-MM-DD') < format(this.startDate, 'YYYY-MM-DD') || format(order.date, 'YYYY-MM-DD') > format(this.endDate, 'YYYY-MM-DD')) {
          //      console.log('false ')
          res = false
        }
        // console.log('this.specialOrdersStatus ', this.specialOrdersStatus)
        keywords.forEach((element, index) => {
          var str = order.UNP + ' ' + order.client + ' ' + order.manager + ' ' + order.good + ' ' + order.response + ' ' + order.type + ' ' + order.number
          var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
          if (res === true && res1 === true) res = true
          if (res === false || res1 === false) res = false
        })

        // console.log(this.debouncedSearch)

        return res
      })

      //      filteredArray.sort((a, b) => {
      //        if (a.number === b.number) {
      //          return a.version - b.version
      //        }
      //        return b.number - a.number
      //      })

      return filteredArray
    },

    groupedRecords () {
      const grouped = {}
      const nonGrouped = []

      this.filteredListSpecialOrders.forEach(record => {
        if (record.number !== '') {
          const key = record.number + '_' + record.UNP
          if (!grouped[key]) {
            grouped[key] = {
              date: record.date,
              number: record.number,
              sklad: record.sklad,
              good: record.good,
              UNP: record.UNP,
              ClientUNP: record.ClientUNP,
              manager: record.manager,
              client: record.client,
              type: record.type,
              quantity: record.quantity,
              data: [{
                guid: record.guid,
                number: record.number,
                version: record.version,
                response: record.response,
                supplier: record.supplier,
                price: record.price,
                term: record.term,
                status: record.status,
                ordernumber: record.ordernumber
              }]
            }
          } else {
            grouped[key].data.push({
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            })
          }
        } else {
          nonGrouped.push({
            date: record.date,
            number: record.number,
            sklad: record.sklad,
            good: record.good,
            UNP: record.UNP,
            ClientUNP: record.ClientUNP,
            manager: record.manager,
            client: record.client,
            type: record.type,
            quantity: record.quantity,
            data: [{
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            }]
          })
        }
      })

      const sortedGrouped = Object.values(grouped).sort((a, b) => a.number - b.number)
      // const sortedGrouped = Object.values(grouped)
      const sortednonGrouped = Object.values(nonGrouped)
      return sortedGrouped.concat(sortednonGrouped).sort((a, b) => a.number - b.number)
    },

    /*
    groupedRecords () {
      const grouped = {}
      const nonGrouped = []

      this.filteredListSpecialOrders.forEach(record => {
        if (record.number !== '') {
          const key = record.number + '_' + record.UNP
          if (!grouped[key]) {
            grouped[key] = {
              date: record.date,
              number: record.number,
              sklad: record.sklad,
              good: record.good,
              UNP: record.UNP,
              ClientUNP: record.ClientUNP,
              manager: record.manager,
              client: record.client,
              type: record.type,
              quantity: record.quantity,
              data: [{
                guid: record.guid,
                number: record.number,
                version: record.version,
                response: record.response,
                supplier: record.supplier,
                price: record.price,
                term: record.term,
                status: record.status,
                ordernumber: record.ordernumber
              }]
            }
          } else {
            grouped[key].data.push({
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            })
          }
        } else {
          nonGrouped.push({
            date: record.date,
            number: record.number,
            sklad: record.sklad,
            good: record.good,
            UNP: record.UNP,
            ClientUNP: record.ClientUNP,
            manager: record.manager,
            client: record.client,
            type: record.type,
            quantity: record.quantity,
            data: [{
              guid: record.guid,
              number: record.number,
              version: record.version,
              response: record.response,
              supplier: record.supplier,
              price: record.price,
              term: record.term,
              status: record.status,
              ordernumber: record.ordernumber
            }]
          })
        }
      })

      // Sort the grouped records based on the guid field in ascending order
      const sortedGrouped = Object.values(grouped)

      // Concatenate the sorted grouped records with the non-grouped records
      return sortedGrouped.concat(nonGrouped).sort((a, b) => a.data[0].guid.localeCompare(b.data[0].guid))
    },
    */
    dataBonus () {
      var data = []
      var len = this.bonus.length
      if (len > 15) len = 15
      for (let i = 0; i < len; i++) {
        data[i] = this.bonus[i].Summa
      }
      return data
    },
    labelsBonus () {
      var data = []
      var len = this.bonus.length
      if (len > 15) len = 15
      for (let i = 0; i < len; i++) {
        data[i] = this.bonus[i].Kontragent
      }
      return data
    },
    chartLabels () {
      var labels = []
      var days = differenceInDays(this.endDate, this.startDate)
      for (let i = 0; i <= days; i++) {
        labels[i] = format(addDays(this.startDate, i), 'DD/MM')
      }
      // console.log(days)
      return labels
    },
    chartData () {
      var data = []
      var days = differenceInDays(this.endDate, this.startDate)
      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        for (let i = 0; i <= days; i++) {
          let orders = this.filteredListVisits.filter(order =>
            differenceInDays(format(order.OrderDate, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0
          )
          // console.log(orders)
          data[i] = orders.length
        }
      } else {
        for (let i = 0; i <= days; i++) {
          let orders = this.filteredListVisits.filter(order =>
            (differenceInDays(format(order.OrderDate, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0) && order.OsnmanagerCode === this.selectedManager.ManagerCode
          )
          // console.log(orders)
          data[i] = orders.length
        }
      }
      // console.log(days)
      return data
    },
    // chartDataUniq () {
    //   var data = []
    //   var days = differenceInDays(this.endDate, this.startDate)
    //   if (this.selectedManager.ManagerCode === 'ВСЕ') {
    //     for (let i = 0; i <= days; i++) {
    //       let orders = this.filteredListVisits.filter(order =>
    //         differenceInDays(format(order.OrderDate, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0
    //       )
    //       // console.log(orders)
    //       let set = new Set()
    //       orders.forEach((order) => {
    //         set.add(order.Login)
    //       })
    //       data[i] = set.size
    //       // console.log(data[i])
    //     }
    //   } else {
    //     for (let i = 0; i <= days; i++) {
    //       let orders = this.filteredListVisits.filter(order =>
    //         (differenceInDays(format(order.OrderDate, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0) && order.OsnmanagerCode === this.selectedManager.ManagerCode
    //       )
    //       // console.log(orders)
    //       let set = new Set()
    //       orders.forEach((order) => {
    //         set.add(order.Login)
    //       })
    //       data[i] = set.size
    //     }
    //   }
    //   // console.log(days)
    //   return data
    // },
    chartDataUniq () {
      var data = []
      var days = differenceInDays(this.endDate, this.startDate)
      var loginMap = {}

      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        this.filteredListVisits.forEach(order => {
          const date = format(order.OrderDate, 'YYYY-MM-DD')
          if (!loginMap[date]) {
            loginMap[date] = new Set()
          }
          loginMap[date].add(order.Login)
        })
      } else {
        this.filteredListVisits.forEach(order => {
          const date = format(order.OrderDate, 'YYYY-MM-DD')
          if (order.OsnmanagerCode === this.selectedManager.ManagerCode) {
            if (!loginMap[date]) {
              loginMap[date] = new Set()
            }
            loginMap[date].add(order.Login)
          }
        })
      }

      for (let i = 0; i <= days; i++) {
        const date = format(addDays(this.startDate, i), 'YYYY-MM-DD')
        data[i] = loginMap[date] ? loginMap[date].size : 0
      }

      return data
    },
    chartLoginUniq () {
      var data = []
      var days = differenceInDays(this.endDate, this.startDate)
      if (this.selectedManager.ManagerCode === 'ВСЕ') {
        for (let i = 0; i <= days; i++) {
          let orders = this.loginLog.filter(order =>
            differenceInDays(format(order.Date, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0
          )
          // console.log(orders)
          let set = new Set()
          orders.forEach((order) => {
            set.add(order.Login)
          })
          data[i] = set.size
          // console.log(data[i])
        }
      } else {
        for (let i = 0; i <= days; i++) {
          let orders = this.loginLog.filter(order =>
            (differenceInDays(format(order.Date, 'YYYY-MM-DD'), format(addDays(this.startDate, i), 'YYYY-MM-DD')) === 0) && order.OsnmanagerCode === this.selectedManager.ManagerCode
          )
          // console.log(orders)
          let set = new Set()
          orders.forEach((order) => {
            set.add(order.Login)
          })
          data[i] = set.size
        }
      }
      // console.log(days)
      return data
    }
  },
  methods: {
    async readReminder (unp) {
      var rem = await ApiService.readReminder(unp)
      // console.log(rem)
      if (rem.data !== null) {
      //  console.log(rem)
        return rem.data
      } else {
        console.log('Нет данных о напоминании')
        return null
      }
    },
    async getQuiz () {
      var list = await ApiService.getQuizList()
      this.quizlist = list.data
      //    console.log(this.quizlist)
      await this.getQuizResults()
      this.$emit('spinneroff')
    },
    async getParsing () {
      /*
      const nightmare = Nightmare()

      nightmare
        .goto('https://zakupki.butb.by/auctions/reestrauctions.html')
        .evaluate(() => {
          const data = []

          const rows = document.querySelectorAll('tr')

          rows.forEach(row => {
            console.log(row)
            const title = row.querySelector('.colLeft:nth-child(2) a').innerText.trim()
            const date = row.querySelector('.colLeft:nth-child(4) span').innerText.trim()
            const price = row.querySelector('.colRight span:nth-child(1)').innerText.trim()

            data.push({ title, date, price })
          })

          return data
        })
        .end()
        .then(result => {
          this.auctions = result
        })
        .catch(error => {
          console.error('Ошибка:', error)
        })
        */
      this.$emit('spinneroff')
    },
    async sendReminder (client) {
      // client.UNP, client.просроченныйДолг,client.днейПросрочки,client.priceCurrency, client.EmailDlyaRassylky
      var comment = 'Уважаемый партнер! \n У вас образовалась просроченная задолженность на сумму ' + client.просроченныйДолг + ' ' + client.priceCurrency + '. \n Просрочка составляет ' + client.днейПросрочки + ' дней. \n Просьба оплатить задолженность в срок до ' + format(addDays(new Date(), 3), 'DD-MM-YYYY') + '. \n \n С уважением, \n Белый картридж'
      // unp = '100511773'
      // contragentEmail = 'valery@infotronic.by'
      var managerEmail = 'valery@infotronic.by'
      let manager = this.managers.find(mng => mng.ManagerCode === client.OsnmanagerCode)
      if (manager) {
        managerEmail = manager.EMail
        console.log(managerEmail)
        // managerEmail = 'valery@infotronic.by'
      }

      try {
        // let res = await ApiService.sendReminder(client.UNP, comment, managerEmail, managerEmail)
        let res = await ApiService.sendReminder(client.UNP, comment, client.EmailDlyaRassylky, managerEmail)
        console.log(res)

        this.$dialog.alert('Напоминание отправлено. Ответ сервера:' + res.statusText)
          .then(function (dialog) {
            // Код, который выполнится после закрытия диалогового окна
          })
      } catch (error) {
        this.$dialog.alert('Не могу отправить напоминание, повторите попытку позже!')
          .then(function (dialog) {
            // Код, который выполнится после закрытия диалогового окна
          })
      }
    },
    fetchDataDolg () {
      this.$emit('load')
      this.excelReady = false
      this.excelData = []
      for (let ind = 0; ind < this.filteredListCRM.length; ind++) {
        let el = this.filteredListCRM[ind]
        // console.log(el)
        this.excelData[ind] = {}
        /*
        'УНП': 'UNP',
        'Контрагент': 'Kontragent',
        'Просроченная BYN': 'просроченныйДолг',
        'Дней просрочки': 'днейПросрочки',
        'Отгружено': 'balance',
        'Оплачено': 'Оплачено',
        'Основной менеджер': 'OsnmanagerCode',
        'Проделанная работа': 'Взаимодействие'
        */
        this.excelData[ind].UNP = el.UNP
        this.excelData[ind].Kontragent = el.Kontragent
        this.excelData[ind].днейПросрочки = el.днейПросрочки
        this.excelData[ind].priceCurrency = el.priceCurrency
        if (el.просроченныйДолг !== undefined) { this.excelData[ind].просроченныйДолг = el.просроченныйДолг.toString().replace('.', ',') } else this.excelData[ind].просроченныйДолг = 0
        this.excelData[ind].OsnmanagerCode = el.OsnmanagerCode
        // this.excelData[ind].Оплачено = el.Оплачено.toString().replace('.', ',')
        this.excelData[ind].Отгружено = el.balance.toString().replace('.', ',')
        this.excelData[ind].Взаимодействие = ''
      }

      return this.excelData
    },
    fetchDataQuiz () {
      this.$emit('load')
      this.excelReady = false
      this.excelData = []
      //    console.log(this.quizResults)
      for (let ind = 0; ind < this.quizResults.length; ind++) {
        let el = this.quizResults[ind]
        //   console.log(el)
        this.excelData[ind] = {}
        this.excelData[ind].id = el.id
        this.excelData[ind].Сфера = el.Сфера
        this.excelData[ind].Парк = el.Парк
        this.excelData[ind].ТрудноНайтиЗапчасти = el.ТрудноНайтиЗапчасти
        this.excelData[ind].ТрудноНайти = el.ТрудноНайти
        this.excelData[ind].Конкуренты = el.Конкуренты
        this.excelData[ind].ЧтоДобавить = el.ЧтоДобавить
        this.excelData[ind].Новости = el.Новости
        this.excelData[ind].АльтНовости = el.АльтНовости
      }

      return this.excelData
    },
    // getSpecialOrderNumber () {
    //   this.maxnumber = 0
    //   this.specialOrders.forEach(ord => {
    //     if (ord.number > this.maxnumber) this.maxnumber = parseInt(ord.number)
    //   })
    //   return this.maxnumber + 1
    // },
    async getSpecialOrders () {
      this.$emit('load')
      console.log('Версия закупера START:' + Math.floor(Date.now() / 1000))
      try {
        await this.getSpecialOrdersListManager()
      } catch (error) {
        console.log(error.message)
      }
      console.log('Заказы Менеджеров START:' + Math.floor(Date.now() / 1000))
      try {
        await this.getSpecialOrdersList()
      } catch (error) {
        console.log(error.message)
      }

      this.maxnumber = 0

      this.specialOrders.forEach(order => {
        if (order.number > this.maxnumber) this.maxnumber = parseInt(order.number)
      })
      console.log('Объединение СТАРТ' + Math.floor(Date.now() / 1000))
      // Create a map for faster lookup
      const orderMngMap = new Map(this.specialOrdersManager.map(order => [order.guid, order]))

      this.specialOrders.forEach(order => {
        if (order.number === '') {
          order.number = this.maxnumber + 1
          this.maxnumber = parseInt(order.number)
          // console.log('номер нового заказа ', order.number)
        }
        const orderMng = orderMngMap.get(order.guid)

        if (orderMng) {
          let dateMng = new Date(orderMng.date)
          let dateOrd = new Date(order.date)
          // console.log(dateMng)
          if (dateMng >= dateOrd) {
            order.date = orderMng.date
          }
          // Update order properties with manager's values

          order.price = orderMng.price
          order.response = orderMng.response
          order.term = orderMng.term
          order.supplier = orderMng.supplier
          if (order.status < orderMng.status) {
            order.status = orderMng.status
          }
          order.ordernumber = orderMng.ordernumber

          if (orderMng.number !== '') {
            order.number = parseInt(orderMng.number)
            if (orderMng.number > this.maxnumber) this.maxnumber = parseInt(orderMng.number)
          } else {
            order.number = this.maxnumber + 1
            this.maxnumber = parseInt(order.number)
          }
          // }
        }
      })

      console.log('Добавление СТАРТ' + Math.floor(Date.now() / 1000))
      //   const nonExistingOrders = this.specialOrdersManager.filter(item => !this.specialOrders.find(order => order.guid === item.guid))
      //   nonExistingOrders.forEach(nonExistingOrder => {
      //     this.specialOrders.push(nonExistingOrder)
      //   })
      // Create a Set for faster lookup
      const orderGuidSet = new Set(this.specialOrders.map(order => order.guid))

      // Use the Set to filter non-existing orders
      const nonExistingOrders = this.specialOrdersManager.filter(item => !orderGuidSet.has(item.guid))

      nonExistingOrders.forEach(nonExistingOrder => {
        this.specialOrders.push(nonExistingOrder)
      })
      this.hidechart = false
      this.$emit('spinneroff')
      // console.log('spinneroff')
      console.log('Добавление КОНЕЦ' + Math.floor(Date.now() / 1000))
    },
    findNonUniqueValues (arr, key, unpKey) {
      let uniqueValues = new Map()
      let nonUniqueValues = new Map()

      for (let i = 0; i < arr.length; i++) {
        if (uniqueValues.has(arr[i][key])) {
          if (uniqueValues.get(arr[i][key]) !== arr[i][unpKey]) {
            nonUniqueValues.set(arr[i][key], [uniqueValues.get(arr[i][key]), arr[i][unpKey]])
          }
        } else {
          uniqueValues.set(arr[i][key], arr[i][unpKey])
        }
      }

      return nonUniqueValues
    },

    updatePrice (value, guid) {
      this.price = value

      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].price = value
        console.log(value)
        this.changeStatus(guid)
      }
    },
    updateSupplier (value, guid) {
      this.supplier = parseInt(value)
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].supplier = this.supplier
        console.log(value)
        this.changeStatus(guid)
      }
    },
    updateTerm (value, guid) {
      this.term = value
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].term = value
        console.log(value)
        this.changeStatus(guid)
      }
    },
    updateResponse (value, guid) {
      this.response = value
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].response = value
        console.log(value)
        this.changeStatus(guid)
      }
    },
    updateStatus (value, guid) {
      this.status = parseInt(value)
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].status = parseInt(value)
        console.log(value)
        this.changeStatus(guid)
      }
    },
    updateOrdernumber (value, guid) {
      this.ordernumber = value
      var suborder = this.specialOrders.filter(suborder => suborder.guid === guid)
      if (suborder.length > 0) {
        suborder[0].ordernumber = value
        console.log(value)
        this.changeStatus(guid)
      }
    },
    selectSpecialOrder (guid) {
      console.log('selected order:', guid)
      this.selectedSpecialOrder = guid
      var selectedOrder = this.specialOrders.filter(order => order.guid === guid)
      if (selectedOrder.length > 0) {
        this.client = selectedOrder[0].client
        this.price = selectedOrder[0].price
        this.term = selectedOrder[0].term
        this.good = selectedOrder[0].good
        this.qty = selectedOrder[0].quantity
        this.ordernumber = selectedOrder[0].ordernumber
        this.response = selectedOrder[0].response
        this.supplier = selectedOrder[0].supplier
        this.type = parseInt(selectedOrder[0].type)
        this.status = parseInt(selectedOrder[0].status)
      }
      // console.log(guid)
    },

    async changeStatus (guid) {
      console.log('Change status ', this.status)
      var temporder = this.specialOrders.filter(order => order.guid === guid)
      // var userfile = {}

      if (temporder.length > 0) {
        this.maxnumber = 0
        console.log('Заказ найден в списке меняем значения полей')
        if (temporder[0].number === '') {
          this.specialOrders.forEach(order => {
            if (order.number > this.maxnumber) this.maxnumber = parseInt(order.number)
          })
          console.log('this.maxnumber ', this.maxnumber)
          temporder[0].number = this.maxnumber + 1
          console.log('Статус ', parseInt(temporder[0].status))
        }
        temporder[0].date = this.formatDate1(new Date())
        temporder[0].status = this.status
        temporder[0].price = this.price
        temporder[0].term = this.term
        temporder[0].supplier = this.supplier
        temporder[0].responce = this.responce
        temporder[0].ordernumber = this.ordernumber

        this.lastStatus = 0
        try {
          await this.writeSpecialOrderFileManager(temporder[0])
        } catch (error) {
          console.error('Error:', error)
          this.errorMessage = 'Ошибка при записи файла. Отсутствует связь с сервером. Несколько последних изменений могут не сохраниться!'
          alert(this.errorMessage)

          return 500 // Return a status code indicating an error
        }

        // console.log(order.UNP, order.manager, order.number, order.date, order.version, order.status)
        if (parseInt(temporder[0].status) === 3) {
          var mess = '<b>' + temporder[0].date + '</b> - ' + 'cпецзаказ № <b>' + temporder[0].number + '-' + temporder[0].version + '</b>' + ' менеджер ' + temporder[0].manager + ' получил статус <b>ОБРАБОТАН</b> ' + this.activeMng.ManagerCode
          // var manager = this.managers.filter(mng => mng.UNP === order.UNP)
          var res = await ApiService.sendTelegramNotification(temporder[0].manager, mess)
          console.log(temporder[0].manager, ' ', mess)

          console.log('Message was sent with status ', res.status)
        }
      } else {
        console.log('Заказ не найден в списке!')
      }
    },

    generateGuid () {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    },
    async writeSpecialOrderFileManager (order) {
      console.log('writeSpecialOrderFileManager ', order.UNP, ' ', order.guid)
      try {
        var userfile = await this.getSpecialOrderFileManager(order.UNP)
      } catch (error) {
        console.error('Error:', error)
        this.errorMessage = 'Ошибка при загрузке файла. Отсутствует связь с сервером. Несколько последних изменений могут не сохраниться!'
        alert(this.errorMessage)
      }
      // Актуализируем заказы из файла кроме текущего заказа
      if (userfile && userfile.data) {
        this.specialOrders.forEach(oldItem => {
          let newItem = userfile.data.find(newItem => newItem.guid === oldItem.guid && oldItem.guid !== order.guid)
          if (newItem) {
            oldItem.number = newItem.number
            oldItem.date = newItem.date
            oldItem.manager = newItem.manager
            oldItem.client = newItem.client
            oldItem.UNP = newItem.UNP
            oldItem.good = newItem.good
            oldItem.quantity = newItem.quantity
            oldItem.price = newItem.price
            oldItem.response = newItem.response
            oldItem.term = newItem.term
            oldItem.sklad = newItem.sklad
            oldItem.type = newItem.type
            oldItem.supplier = newItem.supplier
            oldItem.status = newItem.status
            oldItem.version = newItem.version
            oldItem.ordernumber = newItem.ordernumber
          }
        })
      } else {
        console.error('Userfile data is null or undefined')
      }
      // Найти соответствующий элемент в другом массиве и заменить его значение в исходном массиве

      // let index = this.specialOrders.findIndex(element => element.guid === order.guid)
      // if (index !== -1) {
      //   this.specialOrders[index] = order
      // }

      var temp = this.specialOrders.filter(ord => ord.UNP === order.UNP)

      var orderfile = JSON.stringify(temp)
      var res = await ApiService.writeSpecialOrderFileManager(order.UNP, orderfile)
      console.log('Write srecialOrder file ', res.status)
      return res.status
    },
    async copySpecialOrderFileManager (order) {
      console.log('order', order)
      if (order.number !== '') {
        // var temp = this.specialOrders.filter(ord => ord.UNP === order.UNP)
        // if (temp.length > 0) {
        // var temp1 = temp.filter(ord => ord.guid === order.data[0].guid)
        // if (temp1.length > 0) {
        const newSpecialOrder = {
          number: order.number,
          date: this.formatDate1(new Date()),
          manager: order.manager,
          client: order.client,
          UNP: order.UNP,
          guid: this.generateGuid(),
          good: order.good,
          quantity: order.quantity,
          price: '',
          response: '',
          term: '',
          sklad: parseInt(order.sklad),
          type: parseInt(order.type),
          supplier: 0,
          status: parseInt(order.data[0].status),
          version: order.data.length,
          ordernumber: ''
        }
        this.specialOrders.push(newSpecialOrder)
        this.writeSpecialOrderFileManager(newSpecialOrder.UNP, newSpecialOrder.guid)
        //  }
        //   }

        console.log('Copy specialOrder')
      }
    },
    formatDate1 (date) {
      let formattedDates = ''
      formattedDates = format(date, this.dateFormat1)
      return formattedDates
    },
    async fetchData () {
      this.$emit('load')
      this.excelReady = false
      this.excelData = []
      for (let ind = 0; ind < this.contragents.length; ind++) {
        let el = this.contragents[ind]
        if (el.UNP !== '') {
          this.excelData[ind] = {}
          this.excelData[ind].Manager = el.OsnmanagerCode
          this.excelData[ind].Contragent = el.Kontragent
          this.excelData[ind].UNP = el.UNP
          this.excelData[ind].Visits = this.loginLog.filter(visit => (visit.Login.trim() === el.UNP.trim() && new Date(visit.Date) >= new Date(this.startDate) && new Date(visit.Date) <= new Date(this.endDate))).length

          this.excelData[ind].Orders = this.B2BOrdersList.filter(order => (order.Login.trim() === el.UNP.trim() && new Date(order.OrderDate) >= new Date(this.startDate) && new Date(order.OrderDate) <= new Date(this.endDate))).length

          // this.excelData[ind].Visits = this.loginLog.filter(visit => (visit.Login.trim() === el.UNP.trim())).length
          // this.excelData[ind].Orders = this.B2BOrdersList.filter(order => (order.Login.trim() === el.UNP.trim())).length
          // if (this.bonus.filter(client => (client.UNP === el.UNP)).length > 0) {
          //   this.excelData[ind].Plan = this.bonus.filter(client => (client.UNP === el.UNP))[0].Plan.toString().replace('.', ',')
          //   this.excelData[ind].Prodano = this.bonus.filter(client => (client.UNP === el.UNP))[0].Prodano.toString().replace('.', ',')
          //   this.excelData[ind].ProcentVipolneniya = this.bonus.filter(client => (client.UNP === el.UNP))[0].ProcentVipolneniya.toString().replace('.', ',')
          // }
        }
      }

      return this.excelData
    },
    async fetchDataBonus () {
      this.$emit('load')
      this.excelReady = false
      this.excelData = []
      for (let ind = 0; ind < this.bonus.length; ind++) {
        this.excelData[ind] = {}
        this.excelData[ind].Contragent = this.bonus[ind].Kontragent
        this.excelData[ind].UNP = this.bonus[ind].UNP
        this.excelData[ind].KolBanok = (Math.round(this.bonus[ind].KolBanok / 1) * 1).toString().replace('.', ',')
        this.excelData[ind].ProcSK = (Math.round(this.bonus[ind].ProcSK / 100) * 100).toString().replace('.', ',')
        this.excelData[ind].Summa = (Math.round(this.bonus[ind].Summa * 1) / 1).toString().replace('.', ',')
        this.excelData[ind].SummaSK = (Math.round(this.bonus[ind].SummaSK * 1) / 1).toString().replace('.', ',')
      }

      return this.excelData
    },
    async fetchDataSpecial () {
      this.$emit('load')
      // await this.getSpecialOrders()
      this.excelReady = false
      this.excelData = []
      for (let ind = 0; ind < this.filteredListSpecialOrders.length; ind++) {
        this.excelData[ind] = {}
        this.excelData[ind].number = this.filteredListSpecialOrders[ind].number
        this.excelData[ind].version = this.filteredListSpecialOrders[ind].version
        this.excelData[ind].guid = this.filteredListSpecialOrders[ind].guid
        this.excelData[ind].date = this.filteredListSpecialOrders[ind].date
        this.excelData[ind].manager = this.filteredListSpecialOrders[ind].manager
        this.excelData[ind].client = this.filteredListSpecialOrders[ind].client
        this.excelData[ind].UNP = this.filteredListSpecialOrders[ind].UNP
        this.excelData[ind].ClientUNP = this.filteredListSpecialOrders[ind].ClientUNP
        this.excelData[ind].good = this.filteredListSpecialOrders[ind].good
        this.excelData[ind].quantity = this.filteredListSpecialOrders[ind].quantity
        this.excelData[ind].price = this.filteredListSpecialOrders[ind].price
        this.excelData[ind].response = this.filteredListSpecialOrders[ind].response
        this.excelData[ind].term = this.filteredListSpecialOrders[ind].term
        this.excelData[ind].sklad = this.specialOrdersSkladList[this.filteredListSpecialOrders[ind].sklad]
        this.excelData[ind].type = this.specialOrdersTypeList[this.filteredListSpecialOrders[ind].type]
        this.excelData[ind].supplier = this.suppliers[this.filteredListSpecialOrders[ind].supplier]
        this.excelData[ind].status = this.specialOrdersStatusList[this.filteredListSpecialOrders[ind].status]
        this.excelData[ind].ordernumber = this.filteredListSpecialOrders[ind].ordernumber
      }

      return this.excelData
    },
    finishDownload () {
      this.excelReady = true
      console.log('Excel created')
      this.$emit('spinneroff')
    },
    finishDownloadDolg () {
      this.excelReady = true
      console.log('Excel created')
      this.$emit('spinneroff')
    },
    finishDownloadBonus () {
      this.excelReady = true
      console.log('Excel created')
      this.$emit('spinneroff')
    },
    finishDownloadSpecial () {
      this.excelReady = true
      console.log('Excel created')
      this.$emit('spinneroff')
    },

    escCloseModal (e) {
      if (this.showModal && e.key === 'Escape') {
        this.showModal = false
      }
    },
    async getContragentsInvoices () {
      console.log('Продажи и просрочка начали' + Math.floor(Date.now() / 1000))
      this.$emit('load')
      // this.hidechart = true
      // console.log('hidechart = true')
      this.contragents.forEach((contragent) => {
        var balance = this.clientBalance(contragent.UNP.trim())
        // contragent.напоминаниеОтправлено = this.readReminder(contragent.UNP)
        contragent.balance = balance
        if (balance > 0) {
          var clientInvoices = this.накладные.filter(invoice => (invoice.UNP.trim() === contragent.UNP.trim()))
          clientInvoices.sort((a, b) => differenceInDays(format(b.Date, 'YYYY-MM-DD'), format(a.Date, 'YYYY-MM-DD')))
          // console.log(balance)
          var sum = 0
          var endIndex = 0
          while (sum < contragent.balance && endIndex < clientInvoices.length) {
            sum += clientInvoices[endIndex].Summa
            endIndex++
          }
          var result = clientInvoices.slice(0, endIndex)
          if (sum > contragent.balance) {
            result[endIndex - 1].Summa -= (sum - contragent.balance)
            result[endIndex - 1].Summa = Math.round(result[endIndex - 1].Summa * 100) / 100
          }
          contragent.накладные = result
          contragent.просроченныйДолг = 0
          contragent.накладные.forEach((накладная) => {
            накладная.ДнейДоОплаты = differenceInDays(addDays(накладная.Date, накладная.DneyOtsrochki), Date())
            if (накладная.ДнейДоОплаты < 0) {
              contragent.просроченныйДолг += накладная.Summa
              contragent.датаНачалаПросрочки = накладная.Date
              contragent.днейПросрочки = накладная.ДнейДоОплаты
            }
          })

          contragent.просроченныйДолг = Math.round(contragent.просроченныйДолг * 100) / 100
        }
        // Считаем продажи по месяцам
        const выборка = this.накладные.filter(invoice => (invoice.UNP.trim() === contragent.UNP.trim()))

        contragent.sales = []
        contragent.sales1 = []
        contragent.sales2 = []

        // Продажи по месяцам текущий год
        for (let i = 1; i <= 12; i++) {
          var сумма = 0

          const выборка2 = выборка.filter(invoice => (getYear(invoice.Date) === this.years[0] && getMonth(invoice.Date) === i - 1))
          сумма = выборка2.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.SummaUSD
          }, 0)
          contragent.sales[i - 1] = Math.round(сумма)
        }
        // Продажи по месяцам предыдущий год
        for (let i = 1; i <= 12; i++) {
          сумма = 0

          // if (выборка !== undefined) {
          const выборка3 = выборка.filter(invoice => (getYear(invoice.Date) === this.years[1] && getMonth(invoice.Date) === i - 1))
          сумма = выборка3.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.SummaUSD
          }, 0)
          contragent.sales1[i - 1] = Math.round(сумма)
        }
      })

      console.log('Продажи и просрочки закончили:' + Math.floor(Date.now() / 1000))

      await this.getContragentsABCXYZ()
    },
    async getContragentsABCXYZ () {
      const currentDate = new Date()

      const filteredArray = this.накладные.filter(item => {
        const itemDate = new Date(item.Date)
        const diffInMonths = (currentDate.getFullYear() - itemDate.getFullYear()) * 12 + currentDate.getMonth() - itemDate.getMonth()
        return diffInMonths <= 12
      })

      const groupedByClient = {}
      filteredArray.forEach(item => {
        const clientUNP = item.UNP
        if (!groupedByClient[clientUNP]) {
          groupedByClient[clientUNP] = []
        }
        groupedByClient[clientUNP].push(item)
      })

      const clientsTotalSum = []
      for (const clientUNP in groupedByClient) {
        const clientInvoices = groupedByClient[clientUNP]
        const totalSum = clientInvoices.reduce((acc, curr) => acc + curr.SummaUSD, 0)
        clientsTotalSum.push({ UNP: clientUNP, totalSum })
      }

      clientsTotalSum.sort((a, b) => b.totalSum - a.totalSum)

      const classification = ['A', 'B', 'C']
      const classifiedClients = clientsTotalSum.map((client, index) => {
        const classificationIndex = Math.floor(index / (clientsTotalSum.length / classification.length))
        return { UNP: client.UNP, totalSum: client.totalSum, classification: classification[classificationIndex] }
      })

      const clientsTotalInvoices = []
      for (const clientUNP in groupedByClient) {
        const clientInvoices = groupedByClient[clientUNP]
        const totalInvoices = clientInvoices.length
        clientsTotalInvoices.push({ UNP: clientUNP, totalInvoices })
      }

      clientsTotalInvoices.sort((a, b) => b.totalInvoices - a.totalInvoices)

      const classificationXYZ = ['X', 'Y', 'Z']
      const classifiedClientsXYZ = clientsTotalInvoices.map((client, index) => {
        const classificationIndex = Math.floor(index / (clientsTotalInvoices.length / classificationXYZ.length))
        return { UNP: client.UNP, totalInvoices: client.totalInvoices, classificationXYZ: classificationXYZ[classificationIndex] }
      })

      const finalClassifiedClients = classifiedClients.map(client => {
        const correspondingClient = classifiedClientsXYZ.find(x => x.UNP === client.UNP)
        return { UNP: client.UNP, totalSum: client.totalSum, classification: client.classification, totalInvoices: correspondingClient.totalInvoices, classificationXYZ: correspondingClient.classificationXYZ }
      })

      const finalClassifiedClientsWithInfo = finalClassifiedClients.map(client => {
        const clientInfo = this.contragents.find(item => item.UNP === client.UNP) || {}
        return {
          UNP: client.UNP,
          totalSum: Math.round(client.totalSum),
          classification: client.classification,
          totalInvoices: client.totalInvoices,
          balance: clientInfo.balance || 0,
          priceCurrency: clientInfo.priceCurrency || 'RUB',
          classificationXYZ: client.classificationXYZ,
          Kontragent: clientInfo.Kontragent || 'Нет информации',
          OsnmanagerCode: clientInfo.OsnmanagerCode || 'Нет информации',
          EmailDlyaRassylky: clientInfo.EmailDlyaRassylky || 'Нет информации'
        }
      })

      finalClassifiedClientsWithInfo.forEach(classifiedClient => {
        const contragent = this.contragents.find(contragent => contragent.UNP === classifiedClient.UNP)
        if (contragent) {
          classifiedClient.balance = contragent.balance || 0
          classifiedClient.sales = contragent.sales || []
          classifiedClient.sales1 = contragent.sales1 || []
          classifiedClient.sales2 = contragent.sales2 || []
          classifiedClient.накладные = contragent.накладные || []
          classifiedClient.просроченныйДолг = contragent.просроченныйДолг || 0
          classifiedClient.датаНачалаПросрочки = contragent.датаНачалаПросрочки || null
          classifiedClient.днейПросрочки = contragent.днейПросрочки || 0

          // Добавьте другие поля, если необходимо
        }
      })

      // Вернуть итоговый массив с информацией о классифицированных клиентах и дополнительных данных
      this.classifiedClients = finalClassifiedClientsWithInfo.sort((a, b) => b.totalSum - a.totalSum)
      this.$emit('spinneroff')
    },
    clientBalance (UNP) {
      var res = this.balance.filter(bal => bal.UNP.trim() === UNP.trim())
      if (res.length !== 0) {
        return res[0].Summa
      }
      return 0
    },
    debounceSearch (event) {
      // this.search = ''
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.search = event.target.value
      }, 500)
    },
    debounceClean () {
      this.search = ''
      this.$refs.inp.value = ''
      // console.log(this.$refs.inp.value)
    },
    formatDate (date) {
      let formattedDates = ''
      formattedDates = format(date, 'DD-MM-YYYY')
      return formattedDates
    },
    calculateCompensation () {

    },
    partnerCall (partnerKey, shift) {
      var calls = []
      calls = this.phoneCalls.filter(call => call.АбонентКонтакт === partnerKey)
      // console.log(calls.length)
      if (calls.length > shift) return (this.$moment(calls[shift].Date).format('DD-MM-YYYY') + ': ' + calls[shift].Тема + ' - ' + calls[shift].Описание)
      else return ''
    },
    async getSpecialOrderFile (UNP) {
      // console.log('UNP:' + UNP)
      return new Promise(async (resolve, reject) => {
        try {
          const data = await ApiService.readSpecialOrderFile(UNP)
          resolve(data) // В случае успешного выполнения возвращаем данные
        } catch (error) {
          reject(error) // В случае ошибки возвращаем ошибку
        }
      })
    },
    async getQuizFile (UNP) {
      // console.log('UNP:' + UNP)
      return new Promise(async (resolve, reject) => {
        try {
          const data = await ApiService.readQuizFile(UNP)
          resolve(data) // В случае успешного выполнения возвращаем данные
        } catch (error) {
          reject(error) // В случае ошибки возвращаем ошибку
        }
      })
    },

    async getSpecialOrderFileManager (UNP) {
      // console.log('UNP:' + UNP)
      return new Promise(async (resolve, reject) => {
        try {
          const data = await ApiService.readSpecialOrderFileManager(UNP)
          resolve(data) // В случае успешного выполнения возвращаем данные
        } catch (error) {
          reject(error) // В случае ошибки возвращаем ошибку
        }
      })
    },
    async getSpecialOrdersList () {
      console.log('getSpecialOrdersList')
      try {
        const specialOrders = []
        this.specialOrders = []
        const response = await ApiService.getSpecialOrdersList()
        if (response.data) {
          const promises = response.data.map(specialOrder => this.getSpecialOrderFile(specialOrder.replace(/\.[^/.]+$/, '')))
          const results = await Promise.all(promises)
          if (results && results.length > 0) {
          // var res = results.data
          // console.log(JSON.stringify(results))
            results.forEach(res => {
              // console.log(JSON.stringify(result))
              if (res && res.data) {
                res.data.forEach(result => {
                  const newSpecialOrder = {
                    number: result.number,
                    date: result.date,
                    manager: result.manager,
                    client: result.client,
                    UNP: result.UNP,
                    ClientUNP: result.ClientUNP,
                    guid: result.guid,
                    good: result.good,
                    quantity: result.quantity,
                    price: result.price,
                    response: result.response,
                    term: result.term,
                    type: parseInt(result.type),
                    supplier: parseInt(result.supplier),
                    status: parseInt(result.status),
                    sklad: parseInt(result.sklad),
                    version: result.version,
                    ordernumber: result.ordernumber
                  }
                  specialOrders.push(newSpecialOrder)
                })
              }
            })
            // console.log('Final specialOrders:', specialOrders)
            this.specialOrders = specialOrders
            // this.specialOrders.sort((a, b) => this.parseStringToDate(b.date) - this.parseStringToDate(a.date))
          }
        }
      } catch (error) {
        console.error(error)
      }
    },

    async getQuizResults () {
      console.log('getQuizResults')
      try {
        const quizResults = []
        this.quizResults = []
        const contresp = await ApiService.getContragentsMailFile()
        // console.log(contresp.data.TDSheet)
        const contragents = contresp.data.TDSheet
        const response = await ApiService.getQuizList()

        const promises = response.data.map(quiz => this.getQuizFile(quiz.replace(/\.[^/.]+$/, '')))
        const results = await Promise.all(promises)
        // var res = results.data
        // console.log(JSON.stringify(results))
        results.forEach(res => {
          //   console.log(res.data)
          const newQuiz = {}
          newQuiz.Парк = ''
          newQuiz.ТрудноНайтиЗапчасти = ''
          res.data.forEach(result => {
            //   console.log(result)

            if (result.key === 'id') {
              newQuiz.id = result.value
              const company = contragents.find(company => company.ОбъектКод === result.value)
              if (company) newQuiz.id = company.Объект
            }
            if (result.key === 'Сфера') newQuiz.Сфера = result.value
            if (result.key === 'Парк') newQuiz.Парк += result.value + ' '
            if (result.key === 'ТрудноНайтиЗапчасти') newQuiz.ТрудноНайтиЗапчасти += result.value + ' '
            if (result.key === 'ТрудноНайти') newQuiz.ТрудноНайти = result.value
            if (result.key === 'Конкуренты') newQuiz.Конкуренты = result.value
            if (result.key === 'ЧтоДобавить') newQuiz.ЧтоДобавить = result.value
            if (result.key === 'Новости') newQuiz.Новости = result.value
            if (result.key === 'АльтНовости') newQuiz.АльтНовости = result.value
          })
          quizResults.push(newQuiz)
        })
        this.quizResults = quizResults
      } catch (error) {
        console.error(error)
      }
    },
    async getRemindersList () {
      console.log('getRemindersList')
      try {
        // const reminders = []

        const response = await ApiService.getRemindersList()
        // console.log(response.data)

        const promises = response.data.map(rem => this.readReminder(rem.replace(/\.[^/.]+$/, '')))
        const results = await Promise.all(promises)
        // console.log(results)

        results.forEach(res => {
          // console.log(res)
          var parts = res.split(':')
          console.log(parts)
          var UNP = parts[0]
          var date = parts[1]
          console.log(UNP)
          console.log(date)
          var client = this.classifiedClients.filter(client => client.UNP === UNP)
          console.log(client)
          if (client.length > 0) {
            client[0].ДатаНапоминания = date
          }

          // this.reminders.push(newReminder)
        })
      } catch (error) {
        console.error(error)
      }
    },
    async getSpecialOrdersListManager () {
      console.log('getSpecialOrdersListManager')
      try {
        const specialOrders = []
        this.specialOrdersManager = []
        const response = await ApiService.getSpecialOrdersListManager()
        if (response.data) {
          const promises = response.data.map(specialOrder => this.getSpecialOrderFileManager(specialOrder.replace(/\.[^/.]+$/, '')))
          const results = await Promise.all(promises)
          // var res = results.data
          // console.log(JSON.stringify(results))
          results.forEach(res => {
          // console.log(JSON.stringify(result))
            if (res.data) {
              res.data.forEach(result => {
                const newSpecialOrder = {
                  number: result.number,
                  date: result.date,
                  manager: result.manager,
                  client: result.client,
                  UNP: result.UNP,
                  ClientUNP: result.ClientUNP,
                  guid: result.guid,
                  good: result.good,
                  quantity: result.quantity,
                  price: result.price,
                  response: result.response,
                  term: result.term,
                  type: result.type,
                  supplier: result.supplier,
                  status: result.status,
                  version: result.version,
                  ordernumber: result.ordernumber
                }
                specialOrders.push(newSpecialOrder)
              })
            }
          })
          // console.log('Final specialOrders Managers:', specialOrders)
          this.specialOrdersManager = specialOrders
        } else {
          console.error('No data returned from the API call')
        }
      } catch (error) {
        console.error('Error fetching special orders:', error)
      }
    },
    parseStringToDate (dateString) {
      let dateParts = dateString.split(' ')
      let date = dateParts[0]
      let time = dateParts[1]

      let [day, month, year] = date.split('/')
      let [hours, minutes, seconds] = time.split(':')

      // Месяцы в JavaScript начинаются с 0, поэтому уменьшаем на 1
      let jsDate = new Date(year, month - 1, day, hours, minutes, seconds)

      return jsDate
    },
    // async getB2BOrdersList () {
    //   try {
    //     console.log('getB2BOrdersList')
    //     let response = await ApiService.getB2BOrdersList()
    //     this.B2BOrdersList = response.data
    //     // console.log(JSON.stringify(response.data))
    //     // await new Promise(resolve => setTimeout(resolve, 1))
    //     this.B2BOrdersList.forEach((order) => {
    //       var client = this.contragents.filter(contragent => contragent.UNP.trim() === order.Login.trim())
    //       if (client.length > 0) {
    //         order.Kontragent = client[0].Kontragent
    //         order.OsnmanagerCode = client[0].OsnmanagerCode
    //       } else {
    //         order.Kontragent = 'Неопределен'
    //         order.OsnmanagerCode = 'Неопределен'
    //       }
    //       // console.log(client)
    //     })
    //     this.B2BOrdersList.sort((a, b) => {
    //       let fa = format(a.OrderDate, 'YYYY-MM-DD')
    //       let fb = format(b.OrderDate, 'YYYY-MM-DD')
    //       if (differenceInDays(fa, fb) < 0) {
    //         return -1
    //       }
    //       if (differenceInDays(fa, fb) >= 0) {
    //         return 1
    //       }
    //       return 0
    //     })
    //     this.hidechart = true
    //     console.log('hidechart = true')
    //     setTimeout(() => { this.updateChart() }, 1)
    //     this.$emit('spinneroff')
    //   } catch (error) {

    //   }
    // },
    async getB2BOrdersList () {
      try {
        console.log('getB2BOrdersList')
        let response = await ApiService.getB2BOrdersList()
        this.B2BOrdersList = response.data

        // Create a map of UNP to Kontragent and OsnmanagerCode
        const contragentsMap = this.contragents.reduce((map, contragent) => {
          map[contragent.UNP.trim()] = {
            Kontragent: contragent.Kontragent,
            OsnmanagerCode: contragent.OsnmanagerCode
          }
          return map
        }, {})

        // Assign Kontragent and OsnmanagerCode using the map
        this.B2BOrdersList.forEach((order) => {
          const client = contragentsMap[order.Login.trim()]
          if (client) {
            order.Kontragent = client.Kontragent
            order.OsnmanagerCode = client.OsnmanagerCode
          } else {
            order.Kontragent = 'Неопределен'
            order.OsnmanagerCode = 'Неопределен'
          }
        })

        // Sort B2BOrdersList based on OrderDate
        this.B2BOrdersList.sort((a, b) => {
          let fa = format(a.OrderDate, 'YYYY-MM-DD')
          let fb = format(b.OrderDate, 'YYYY-MM-DD')
          return differenceInDays(fa, fb)
        })

        this.hidechart = true
        console.log('hidechart = true')
        setTimeout(() => { this.updateChart() }, 1)
        this.$emit('spinneroff')
      } catch (error) {
        // Handle error
      }
    },
    async getLoginLog () {
      console.log('getLoginLog')
      let response = await ApiService.getLoginLog()
      this.loginLog = response.data

      // Create a map of UNP to OsnmanagerCode
      const contragentsMap = this.contragents.reduce((map, contragent) => {
        map[contragent.UNP.trim()] = contragent.OsnmanagerCode
        return map
      }, {})

      // Update OsnmanagerCode for each login in loginLog
      this.loginLog.forEach((login) => {
        login.Date = new Date(login.Date)
        login.OsnmanagerCode = contragentsMap[login.Login.trim()] || 'Not found'
      })
    },
    async makeCall (contragent) {
      this.contragentName = contragent.Description
      this.partnerKey = contragent.Партнер_Key
      const response = await ApiService.getPhone(this.partnerKey)
      let data = response.data.value
      this.phone = ''
      this.tag = ''
      this.message = ''
      if (data.length > 0) {
        data.forEach((phone) => {
          // console.log(phone.НомерТелефона)
          this.phone += phone.НомерТелефона + ' '
        })
      }
      // this.phone
      this.showModal = true
    },
    async postConversation () {
      console.log('partnerKey ' + this.partnerKey)
      let response = await ApiService.createConversation(this.partnerKey, this.contragentName, this.selectedManager, this.phone, this.tag, this.message)
      console.log(response.data)
      this.getPhoneCalls()
    },
    async getPhoneCalls () {
      console.log('getPhoneCalls')
      let response = await ApiService.getPhoneCalls()
      this.phoneCalls = response.data.value
    },
    async writePercent () {
      console.log('writePercent')
      let response = await ApiService.writePercent(this.addedPercent + this.currentPercent)
      console.log(response)
    },
    async getClientBalance (partnerkey) {
      if (this.partnersPayments[partnerkey] === undefined) {
        console.log('Get client balance' + partnerkey)
        const response = await ApiService.getClientBalance(partnerkey, '30')
        let data = response.data.value
        // console.log(data[0].Просрочено)
        if (data[0].Просрочено === undefined) this.partnersPayments[partnerkey] = 0
        else this.partnersPayments[partnerkey] = data[0].Просрочено
      }
    },
    year () {
      var date = new Date()
      var year = date.getFullYear().toString()
      // console.log('YEAR:' + year)
      this.years[0] = year - 1 + 1
      this.years[1] = year - 1
      this.years[2] = year - 2
    },
    async updateChart () {
      // this.hidechart = true
      await new Promise(resolve => setTimeout(resolve, 10))
      // await this.$emit('loaded')

      // this.$nextTick(() => {
      // this.$emit('spinneroff')
      this.hidechart = false
      //  console.log('hidechart = false')
      // })
    },
    barChartData () {
      var bcd = {}
      bcd = {
        labels: this.chartLabels,
        datasets: [
          {
            label: 'Уникальных посетителей:',
            data: this.chartLoginUniq,
            backgroundColor: 'lightgreen',
            borderWidth: 1
          },
          {
            label: 'Всего заказов из B2B:',
            data: this.chartData,
            backgroundColor: '#33b5e5',
            borderWidth: 1
          },
          {
            label: 'Уникальных заказов из B2B:',
            data: this.chartDataUniq,
            backgroundColor: 'orange',
            borderWidth: 1
          }
        ]
      }
      return bcd
    },
    barChartDataBonus () {
      var bcd = {}
      bcd = {
        labels: this.labelsBonus,
        datasets: [
          {
            label: 'Сумма закупок:',
            data: this.dataBonus,
            backgroundColor: 'lightgreen',
            borderWidth: 1
          }
        ]
      }
      this.$emit('spinneroff')
      return bcd
    },
    barChartData1 (contragent) {
      var bcd = {}
      bcd = {
        labels: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сент', 'Окт', 'Ноя', 'Дек'],
        datasets: [
          {
            label: this.years[0],
            data: contragent.sales,
            backgroundColor: 'lightgreen',
            borderWidth: 1
          },
          {
            label: this.years[1],
            data: contragent.sales1,
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            borderWidth: 1
          } /*,
          {
            label: this.years[2],
            data: contragent.sales2,
            backgroundColor: 'lightblue',
            borderWidth: 1
          } */
        ]
      }
      return bcd
    },
    lineChartData () {
      var lcd = {}
      lcd = {
        labels: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        datasets: [
          {
            label: this.years[0],
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            data: this.managerSalesTotal[0]
          },
          {
            label: this.years[1],
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            data: this.managerSalesTotal[1]
          },
          {
            label: this.years[2],
            backgroundColor: 'rgba(90, 173, 246, 0.5)',
            data: this.managerSalesTotal[2]
          }
        ]
      }
      return lcd
    },
    plan (contragent) {
      var daysdiff = this.diffdays()
      if (daysdiff === 0) daysdiff = 1
      return Math.round(contragent.sales / 365 * daysdiff)
    },
    plantotal () {
      var sales = 0
      var daysdiff = this.diffdays()
      if (daysdiff === 0) daysdiff = 1
      this.filteredList.forEach((contragent) => {
        sales += contragent.sales
      })
      this.totalplan = Math.round(sales / 365 * daysdiff)
      return this.totalplan
    },
    salestotal () {
      var sales = 0
      this.filteredList.forEach((contragent) => {
        sales += this.turnover(contragent.АналитикаУчетаПоПартнерам_Key)
      })
      this.totalsales = Math.round(sales)
      return this.totalsales
    },
    partnerDebt (partneranakey) {
      var debt = 0
      var s = 0
      var p = 0
      var arr = this.partnersSales.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      if (arr.length > 0) {
        s = arr[0].СуммаВыручкиСНДСРеглTurnover
        console.log('s ' + s)
      }
      arr = this.partnersPayments.filter(payment => payment.АналитикаУчетаПоПартнерам_Key === partneranakey)
      if (arr.length > 0) {
        p = arr[0].СуммаReceipt
        console.log('p ' + p)
      }
      debt = s - p
      // console.log(debt)
      return debt
    },
    profittotal () {
      var sales = 0
      this.filteredList.forEach((contragent) => {
        sales += this.profit(contragent.АналитикаУчетаПоПартнерам_Key)
      })
      this.totalprofit = Math.round(sales)
      return this.totalprofit
    },
    profittotalUpr () {
      var sales = 0
      this.filteredList.forEach((contragent) => {
        sales += this.profitUpr(contragent.АналитикаУчетаПоПартнерам_Key)
      })
      this.totalprofitUpr = Math.round(sales)
      return this.totalprofitUpr
    },
    diffdays () {
      // console.log(differenceInDays(this.endDate, this.startDate))
      return differenceInDays(this.endDate, this.startDate)
    },
    turnover (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result)
      if (result.length === 0) return 0
      else {
        var sum = 0
        result.forEach((el) => {
          sum += el.СуммаВыручкиБезНДСTurnover
        })
        return Math.round(sum)
      }
    },
    profit (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result.length)
      if (result.length === 0) return 0
      else {
        var sum = 0
        result.forEach((el) => {
          sum += (el.СуммаВыручкиБезНДСTurnover - el.СтоимостьБезНДСTurnover)
        })
        return sum
      }
    },
    profitUpr (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result.length)
      if (result.length === 0) return 0
      else {
        var sum = 0
        result.forEach((el) => {
          sum += (el.СуммаВыручкиБезНДСTurnover - el.УпрСебестоимость)
        })
        return sum
      }
    },
    profitPercent (partneranakey) {
      const result = this.partnersSalesByPeriod.filter(sales => sales.АналитикаУчетаПоПартнерам_Key === partneranakey)
      // console.log(result)
      if (result.length === 0) return 0
      else return 100 * (result[0].СуммаВыручкиБезНДСTurnover - result[0].СтоимостьБезНДСTurnover) / result[0].СуммаВыручкиБезНДСTurnover
    },
    element (contragent) {
      return contragent.Ref_Key
    },
    calculateInput (good, event) {
      // console.log(event.target.value)
      if (event.target.value <= 0) {
        event.target.value = ''
        return ''
      } else {
        return event.target.value
      }
    },
    ChangeItem (good) {
      this.$emit('orderedItems')
    },
    calculateid (refkey) {
      return 'i' + refkey
    },
    transit (good) {
      return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
    },
    searchFocus (str) {
      this.showOnce = false
      this.$refs.inp.focus()
      // console.log(str)
      this.search += str
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group-text-sm {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0.01rem 0.01rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
  padding-top: 10px;
}

.btn-to-top {
  border-radius: 50%;
  padding: 1rem;
  padding-top: 0.9rem;
  padding-right: 1.1rem;
  padding-bottom: 0.9rem;
  padding-left: 1.1rem;
}

.btn.btn-nav {
  padding: 0.1rem 1.0rem;
  font-size: 0.64rem;
}

.badge-pill {
  border-radius: 10rem;
  padding-right: 0.6em;
  margin-top: 0.6em;
}

.form-control:focus {
  border: 0px
}

.form-control {
  height: auto
}
</style>



// WEBPACK FOOTER //
// src/components/Sales.vue